import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function EditUnitItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    return (
        <ContextMenuItem
            data-pendo-id="menu-item-edit-unit"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                drawerControls.open({
                    type: 'log-on-edit-unit',
                    props: { unitId: clickParams.unitId },
                });
            }}
        />
    );
}
